import React, { useEffect, useState } from 'react';
import GraphiQL from 'graphiql';
import fetch from 'isomorphic-fetch';
import { useParams } from 'react-router-dom';
import { config } from 'config';

export function AppApiGraphiQL() {
    const { installId } = useParams<{ installId: string }>();
    const [token, setToken] = useState(null);

    useEffect(() => {
        if (installId) {
            fetch(`${config.baseUrl}/api/graphql/token/` + installId, {
                method: 'get',
                credentials: 'include',
            }).then(response => {
                response.json().then(data => {
                    setToken(data.accessToken);
                });
            });
        }
    }, [installId]);

    if (token === null && installId) {
        return <div>Loading...</div>;
    }

    const graphQLFetcher = graphQLParams => {
        return fetch(`${config.baseUrl}/api/graphql`, {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Bokun-App-Access-Token': token,
            },
            credentials: 'include',
            body: JSON.stringify(graphQLParams),
        }).then(response => response.json());
    };

    return (
        <div id="graphiql" style={{ height: '100vh' }}>
            <GraphiQL fetcher={graphQLFetcher} />
        </div>
    );
}
